import { IAttachmentEntity } from '../entitites/attachments.entity';

export class AttachmentDto {
  encodedDocument: string;
  filename: string;
  mimetype: string;

  constructor(entity: IAttachmentEntity) {
    this.encodedDocument = entity.encoded_document;
    this.filename = entity.filename;
    this.mimetype = entity.mimetype;
  }
}
